import { I18nUtil } from 'common-utils';

import { pdsLocalStorage } from './pds-local-storage';
import { pdsUtils } from './pds-utils';

//TODO Import CKEDITOR rather than rely on CKEDITOR being a part of the global scope
declare let CKEDITOR: any;

// this is not exported because we want pds to only expose a singleton object not a class.
class PdsI18n extends I18nUtil {
  pds = undefined;
  newMessageKeys: { [key: string]: string } = {};
  ckEditorEnglishMessages: { [key: string]: string } = {};

  setLocale(locale): void {
    this.locale = locale;

    let elements = document.querySelectorAll('.pds-widget');
    for (let i = 0; i < elements.length; i++) {
      let element: any = elements[i];
      if (typeof element.messageKeysUpdated === 'function') {
        element.messageKeysUpdated();
      }
    }
  }

  /**
   * This function is intended for developers to use from the console to get access to the message keys that are being
   * used that are not coming from the server.
   */
  getNewMessageKeys(): string {
    let result = '';
    for (let key of Object.keys(this.newMessageKeys)) {
      result += `"${key}": "${this.newMessageKeys[key]}",\n`;
    }
    return result;
  }

  /**
   * Takes a key like 'pds|a late assignment|late' and turns it into 'late'.
   */
  stripContextFromKey(key: string): string | undefined {
    let message = super.stripContextFromKey(key);
    if (message != null && pdsLocalStorage.getPersistedBoolean('dev-mode')) {
      this.newMessageKeys[key] = message;
    }
    return message;
  }

  /**
   * This function replaces the english strings inside a ckEditor messageKeysTree with localized strings from what the
   * i18n-message service returns.  CK Editor never knows that it is showing anything other than English strings.
   *
   * This function is recursive so that it can traverse down the branches of the tree.
   * @param messageKeysTree
   * @param scope - The bread crumbs for how far down we are in the messageKeysTree. Ex:  'CKEDITOR.lang.en.buttons.OK
   */
  updateCKEditorMessageKeys(messageKeysTree: Object, scope = ''): void {
    for (let key of Object.keys(messageKeysTree)) {
      let current: string | Object = messageKeysTree[key];
      if (typeof current === 'string') {
        let message: string = current;
        let englishMessagesKey = scope + '.' + key;
        if (!this.ckEditorEnglishMessages.hasOwnProperty(englishMessagesKey)) {
          //only assign this once because the message will only be in
          //English (for sure) the first time through this loop.
          this.ckEditorEnglishMessages[englishMessagesKey] = message;
        }

        let englishMessage = this.ckEditorEnglishMessages[englishMessagesKey];
        let messageKey = 'pds|ckeditor|' + englishMessage;

        //Replace the message string with a localized string.
        //This means that we are replacing the English string with the selected language string.
        //CK Editor still thinks it's working with English.
        messageKeysTree[key] = this.getText(messageKey);
      } else {
        this.updateCKEditorMessageKeys(current, scope + '.' + key);
      }
    }
  }
}

// flattening this object so that we don't have a prototype inheritance hierarchy
export let pdsI18n = pdsUtils.createFlattenedClassInstance(PdsI18n);

//This is where we define the default message keys for Polymer that use arguments.
//This is also the place for any other message keys that have a different text than the key.
pdsI18n.messageKeys['pds|popover|Navigating From Single Element'] = 'Alert: navigating away from this entry will close the popup menu';
pdsI18n.messageKeys['pds|popover|Forwards From Last Element'] = 'Alert: navigating past the last entry will close the popup menu';
pdsI18n.messageKeys['pds|popover|Backwards From First Element'] = 'Alert: navigating backwards past the first entry will close the popup menu';
pdsI18n.messageKeys['pds|copyright clause|Copyright Clause'] = '© 2010-2018 PowerSchool Group LLC and/or its affiliate(s). All rights reserved. All trademarks are either owned or licensed by PowerSchool Group LLC and/or its affiliates.';
pdsI18n.messageKeys['pds|close-message'] = 'Close {{arg0}} Navigation';
pdsI18n.messageKeys['pds|class picker|xx Classes'] = '{{arg0}} Classes';
pdsI18n.messageKeys['pds|circular progress|xx% Complete'] = '{{percent}}% Complete';
pdsI18n.messageKeys['pds|circular progress|xx of xx'] = '{{value}} of {{max}}';
pdsI18n.messageKeys['pds|class picker|xx - xx Classes'] = '{{arg0}} - {{arg1}} Classes';
pdsI18n.messageKeys['pds|grid widget|Select xx'] = 'Select {{selectCriteria}}';
pdsI18n.messageKeys['pds|grid widget|Remove Filter xx yy'] = 'Remove Filter {{filterName}} {{filterValue}}';
pdsI18n.messageKeys['pds|grid widget|xx Results'] = '{{number}} Results';
pdsI18n.messageKeys['pds|notifications|Messages regarding xx'] = 'Messages regarding {{name}}';
pdsI18n.messageKeys['pds|search|student dropped xx classes'] = 'student dropped {{arg0}} classes';
pdsI18n.messageKeys['pds|search|xx photo'] = '{{arg0}}\'s photo';
pdsI18n.messageKeys['global|Select Previous xx'] = 'Select Previous {{item}}';
pdsI18n.messageKeys['global|Select Next xx'] = 'Select Next {{item}}';
pdsI18n.messageKeys['pds|global create menu widget|Navigate to xx xx'] = 'Navigate to {{arg0}} {{arg1}}';
pdsI18n.messageKeys['pds|global create menu widget|Set xx xx to default action'] = 'Set {{arg0}} {{arg1}} as default action';
pdsI18n.messageKeys['cu|multi-select|Remove Selection Status xx'] = 'Remove Selection Status {{selectionStatus}}';
pdsI18n.messageKeys['pds|logout|Sign out of all xx Authenticated applications'] = 'Sign out of all {{authenticationType}} Authenticated applications';
